import { useRouter } from 'next/router';
import React from 'react';
import WidgetFollow from 'src/components/widgets/widget-follow';
import { APP_IMG } from 'src/constants';
import { DATALAYER_TYPE } from 'src/utils/datalayer/send-datalayer';
import styled from 'styled-components';

function HangOverFooter() {
  const router = useRouter();
  return (
    <FooterWrapper background={`${APP_IMG}/images/hangover/footer-bg.jpg`}>
      <div className='container content'>
        <div className='left'>
          <WidgetFollow
            //! DATALAYER
            eventDataLayer={{
              type: DATALAYER_TYPE.TRACK_POSITION,
              router: router?.pathname,
              section: 'follow',
              position: 'on:header'
            }}
          />
        </div>
        <div className='right'>
          <div className='text'>© THE PEOPLE ALL RIGHTS RESERVED.</div>
          <img className='image' src='https://thepeople.my.canva.site/hang-over/images/e4942d01a7cc6938322b478b8463a4b9.svg' />
        </div>
      </div>
    </FooterWrapper>
  );
}
interface StyledProps {
  background: string;
}
const FooterWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  padding: 30px 0;
  background-image: url(${props => props?.background});
  background-size: cover;
  background-position: bottom center;
  @media (max-width: 767px) {
    background-image: none;
    background-color: #eb3243;
  }
  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 767px) {
      flex-direction: column;
      gap: 20px;
    }
    .left {
      width: fit-content;
      #widget-follow {
      }
    }
    .right {
      width: fit-content;
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 50%;
      @media (max-width: 767px) {
        width: 100%;
      }
      @media (max-width: 475px) {
        flex-direction: column;
      }
      .text {
        font-weight: 400;
        color: white;
        font-size: 14px;
        @media (max-width: 767px) {
          font-size: 12px;
        }
      }
      .image {
        width: 40%;
      }
    }
  }
`;
export default HangOverFooter;
